import type { ThemeKey } from '@src/theme'
import { useTheme } from '@ui/theme'

interface IllustrationSizes {
  base: string
  x2: string
  x3: string
}

export type IllustrationType = Record<ThemeKey, IllustrationSizes>

interface IllustrationProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string
  illustration: IllustrationType
}

/**
 * @deprecated Use `@ui/Illustration` instead. Add an `alt` if needed (when not needed, leave it as an empty string) when making the change.
 */
export default function Illustration({ illustration, ...props }: IllustrationProps) {
  const theme = useTheme()
  const sizes = illustration[theme.themeKey]

  return <img src={sizes.base} srcSet={`${sizes.x2} 2x, ${sizes.x3} 3x`} {...props} />
}
